import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Text from "../Text/Text";
import useBreakpoints from "../hooks/useBreakpoints";
import Progress from "../Progress";
import styles from "./CurrentRanking.module.scss";

const DESCRIPTIONS = [
  {
    description:
      "Limited insights into how to implement digital transformation.",
    title: "Nascent",
  },
  {
    description:
      "Challenged in scaling success. Delivers pockets of digital transformation.",
    title: "Developing",
  },
  {
    description:
      "Consistently evolving and processing digital transformation to meet changing market needs.",
    title: "Maturing",
  },
  {
    description:
      "Driving innovative digital transformation business models which offer unique experiences to the market.",
    title: "Leading",
  },
];

function CurrentRanking(props) {
  const { active: activeBreakpoint } = useBreakpoints();
  const { rankingPercentage, rankingText } = props;
  return (
    <Section>
      <Wrapper>
        <Text
          variant={activeBreakpoint === "sm" ? "bodyLarge" : "subheading"}
          weight="bold"
          className={styles.intro}
        >
          Where do you currently rank?
        </Text>
        <Ranking
          rankingPercentage={rankingPercentage}
          rankingText={rankingText}
        />
      </Wrapper>
    </Section>
  );
}

export default CurrentRanking;

/** Section to contain the scores */
function Section({ children }) {
  return <section className={styles.section}>{children}</section>;
}

/** Wrapper to contain graphic & scores */
function Wrapper({ children }) {
  return <div className={styles.wrapper}>{children}</div>;
}

/** Houses the ranking progress bar with the indicator */
function Ranking(props) {
  const { rankingPercentage, rankingText } = props;
  const [newRanking, setNewRanking] = useState(0);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setNewRanking(rankingPercentage);
    }, 2400);
    return () => clearTimeout(timeout);
  }, [rankingPercentage]);
  return (
    <div className={styles.ranking}>
      <RankIndicator progress={newRanking} />
      <Progress speed="slower" size="lg" progress={newRanking} />
      <RankDescriptions>
        {DESCRIPTIONS.map((d) => (
          <Description
            key={d.title}
            title={d.title}
            description={d.description}
            rankingText={rankingText}
          />
        ))}
      </RankDescriptions>
    </div>
  );
}

/** Indicator to show above progress bar */
function RankIndicator(props) {
  const { progress } = props;
  const style = {
    left: `${progress}%`,
  };
  return <div style={style} className={styles.ranking_indicator} />;
}

/** Contains the ranking descriptions */
function RankDescriptions({ children }) {
  return <div className={styles.descriptions}>{children}</div>;
}

/** Descriptions for the rankings */
function Description(props) {
  const { title, description, rankingText } = props;
  const descriptionClasses = cx(styles.description, {
    [styles.active]: rankingText === title,
  });
  return (
    <div className={descriptionClasses}>
      <Text
        className={styles.description_title}
        weight="bold"
        variant="bodyLarge"
      >
        {title}
      </Text>
      <Text className={styles.description_body}>{description}</Text>
    </div>
  );
}

Description.propTypes = {
  active: PropTypes.bool,
  description: PropTypes.string,
  title: PropTypes.string,
};
